/**
 * Created by RKL on 07/09/2015.
 */
define('adminKitProtDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminKitProtDetailsView',
  'emptyView',
  'kitProtDetailTabController',
  'adminKitprController',
  'rolesMixin',
  'settings',
  'entities/kitprots'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  kitProtDetailTabController,
  adminKitprController
) {
  'use strict';

  var KitProtsDetailsController = {
    fetchKitProt: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showKitProt(data);
      } else {
        this.model = App.request('kitprot:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showKitProt(data);
          }
        });
      }
    },

    showKitProt: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'kitprot:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (kitProt) {
      this.view.onHeaderChange(kitProt);
    },

    displayTabs: function(data) {
      for (var region in this.view.regions) {
        if (App.regions.getRegion('main') && App.regions.getRegion('main').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content') &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView &&
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region)) {
          var currentViewRegion = App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion(region).currentView;
          if(currentViewRegion) {
            currentViewRegion.destroy();
          }
        }
      }

      if (data.tab) {
          switch (data.tab.name) {
              case 'kitpr':
                  adminKitprController.showKitprList(data);
                  break;
              default:
                  kitProtDetailTabController.showTab(data);
                  break;
          }
      } else {
          kitProtDetailTabController.showTab(data);
      }


      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/kitprots/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = KitProtsDetailsController;
});
